import React from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import ListingsPerseus from '../components/ListingsPerseus';
import withRequestContext from '../components/hoc/withRequestContext';
import { ClientListingsPropTypes } from '../types';

const ClientListings = (props) => {

    useImpressionManager();

    const {
        listings,
        appData,
        displayData,
        topBarSorting,
        errorContext,
        assumedLanguage,
        requestContext,
        knownCrawler,
        tracking
    } = props;

    return (
        <ListingsPerseus displayData={displayData}
            topBarSorting={topBarSorting}
            listings={listings}
            appData={{ ...appData, assumedLanguage }}
            requestContext={requestContext}
            knownCrawler={knownCrawler}
            tracking={tracking}
            errorContext={errorContext}/>
    );
};

ClientListings.propTypes = ClientListingsPropTypes;

const ListingsWithRequestContext = withRequestContext(ClientListings);

export default ListingsWithRequestContext;
